import InfoRounded from "@mui/icons-material/InfoRounded";
import { Box, Paper } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import { OktaAuth } from "@okta/okta-auth-js";
import "@okta/okta-auth-js/polyfill";
import { Router, navigate /*, Link */ } from "@reach/router";
import axios from "axios";
import _ from "lodash";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AssignedItemDeliveryPage from "./components/Delivery-Report/assigned-items";
import MyDeliveryPage from "./components/Delivery-Report/my-deliveries";
import OutofDeliveryPage from "./components/Delivery-Report/out-of-delivery";
import StockedItemDeliveryPage from "./components/Delivery-Report/stocked-items";
import AccountList from "./components/account-list";
// import Appointment from "./components/appointment/";
import AssignPrescriptions from "./components/assign-prescriptions";
import EmailAutomationComponent from "./components/automation/email-automation/index";
import BoxList from "./components/box-list";
import BinMapping from "./components/bin-mapping";
import BinOrderMappings from "./components/bin-order-mappings";
import BinMovementHistory from "./components/bin-movement-history";
import USER_ROLES from "./components/common/userroles";
import ConsolePage from "./components/console";
import DashboardGate from "./components/dashboardGate";
import MessagingBilling from "./components/billing/MessagingBilling";
import BillingAnalytics from "./components/billing/BillingAnalytics";
import InvoiceList from "./components/billing/InvoiceList";
import Home from "./components/home";
import Login from "./components/login";
import PatientList from "./components/patient-list";
import PendingDeliveriesPage from "./components/pending-deliveries";
import ReleaseHistory from "./components/releaseHistory";
import AssignedItems from "./components/reports/assigned-items";
import CancelledLists from "./components/reports/cancelled-list";
import ConsoleReport from "./components/reports/console-report";
import ConsultReport from "./components/reports/consultation";
import EnrolledPatients from "./components/reports/enrolled-patients";
import ExpiredItems from "./components/reports/expired-items";
import HistoryLists from "./components/reports/history";
import IpayTransactions from "./components/reports/ipay_transaction";
import IpayReceivables from "./components/reports/ipay_receivables";
import KioskBoxUtilizationComponent from "./components/reports/kiosk-box-utilization/index";
import EnrolledLoyaltyMembers from "./components/reports/loyalty-members";
import OrderView from "./components/reports/orders-view";
import PayrollDeductions from "./components/reports/payroll-deductions";
import PhiLogs from "./components/reports/phi-logs/index";
import PickUpLists from "./components/reports/pickup";
import ControlledSubstanceDispensedReport from "./components/reports/controlled-substance-dispensed";
import ScheduleConsultReport from "./components/reports/schedule-consultation";
import StockLists from "./components/reports/stock-list";
import SurveyReport from "./components/reports/survey-report";
import TemperatureHistory from "./components/reports/temparature_history/index";
import TemparatureMonitoring from "./components/reports/temparature_monitoring/index";
import TransactionLists from "./components/reports/transaction";
import InActiveUsersReportComponent from "./components/reports/users-inactive-report/index";
import TaskManagerComponent from "./components/taskmanager/index";
import UnpluggedAssignPrescriptions from "./components/unplugged-assign-prescriptions";
import UserAdd from "./components/user-add";
import UserList from "./components/user-list";
import RolePermissions from "./components/user-role";
import cookies from "./utils/cookies";
import pingOIDC from "./utils/pingOIDC";
import VendorList from "./components/vendor-list";
import VendorOrders from "./components/reports/vendor-orders";
import AuditReportComponent from "./components/reports/audit-report";
import PurgeTrail from "./components/reports/purge-trail";
import CreateOrder from "./components/retail-orders";
import RetailAssignedItems from "./components/reports/retail-assigned-items"
import RetailStockedItems from "./components/reports/retail-stocked-items"
import RetailPickedupItems from "./components/reports/retail-pickuped-items"
import RetailRemovedItems from "./components/reports/retail-removed-items";
import RetailTransactionDetail from "./components/reports/retail-transactionDetail";
import CycleReview from "./components/reports/cycle-review";
import HLOrderView from "./components/reports/hl_orders_view";
import MessageLog from "./components/reports/message-log";
import GroupManagement from "./components/group-management";
import RoleManagement from "./components/role-management";
import * as serviceWorker from "./serviceWorker";
import CryptoJS from "crypto-js";
import { initNotificationHandler } from './config/notification-handler';
import ComplianceReconciliation from "./components/reports/ComplianceReconciliation";
import InheritPermissions from "./components/InheritPermission";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LOCATION_TYPE from "./components/enum/location_type";
import { MultiTabProvider } from "./context/MultiTabContext";
import { writeAuditLog } from "./components/common/apis";
import { setupTokenExpiryHandler, persistAutoLogoutAccountSetting } from "./utils/tokenExpiryHandler";
import { checkBrowserDetailsAfterLogin } from "./utils/browserFingerprint";
import SystemNoticeBanner from "./system-notices/SystemNoticeBanner";

const styles = () => ({
  gradient: {
    backgroundImage: "linear-gradient(135deg, white, #dedede)",
    minWidth: "100%",
    minHeight: "100%",
    overflow: "hidden",
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "2.125rem",
    fontWeight: 400,
    lineHeight: "1.20588em",
    marginLeft: "1rem",
  },
  /** Compact title used only on Deliver Prescription (assign / unplugged) */
  assignTypography: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "1.15rem",
    fontWeight: 600,
    lineHeight: 1.25,
    marginLeft: "0.75rem",
    marginBottom: 0,
    letterSpacing: "-0.01em",
  },
  paper: {
    marginTop: "16px",
    marginLeft: "1rem",
    marginRight: "1rem",
    overflowY: "auto",
    height: "auto",
    marginBottom: "2rem",
  },
  main: {
    marginTop: "15px",
  },
  assignMain: {
    marginTop: "15px",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
});

// Encrypt function: takes a plaintext string and returns an encoded ciphertext
const encrypt = (text) => {
  try {
    const ciphertext = CryptoJS.AES.encrypt(text, process.env.REACT_APP_RETAIL_ENC_KEY).toString();
    return encodeURIComponent(ciphertext);
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

const AssignPrescription = (props) => {
  // Hide heading when location type is Counter
  const selectedLocationTypeId = localStorage.getItem('selectedLocationTypeId');
  const isCounter = selectedLocationTypeId === LOCATION_TYPE.Counter;
  
  return (
    <Box component="div" className={props.classes.assignMain}>
      {!isCounter && (
        <Typography
          id="react-no-print"
          variant="h6"
          className={props.classes.assignTypography}
        >
          {props.i18n("Assign.DeliverPrescription")}
        </Typography>
      )}
      <Box component="div" sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <AssignPrescriptions />
      </Box>
    </Box>
  );
};

const UnpluggedAssignPrescription = (props) => (
  <Box component="div" className={props.classes.assignMain}>
    <Typography
      id="react-no-print"
      variant="h6"
      className={props.classes.assignTypography}
    >
      {props.i18n("Unplugged.DeliverPrescription")}
    </Typography>
    <Box component="div" sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <UnpluggedAssignPrescriptions />
    </Box>
  </Box>
);

const TransactionList = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Transaction.TransactionsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      {[false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail")) ? (
        <TransactionLists />
      ) : (
        <RetailTransactionDetail />
      )}
    </Paper>
  </div>
);

const StockList = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      id="react-no-print"
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Stocked.StockedItemsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      {[false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail")) ? (
        <StockLists />
      ) : (
        <RetailStockedItems />
      )}
    </Paper>
  </div>
);

const PickUpList = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Picked.PickedUpItemsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      {[false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail")) ? (
        <PickUpLists />
      ) : (
        <RetailPickedupItems />
      )}
    </Paper>
  </div>
);

const ControlledSubstanceDispensedList = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.ControlledSubstance.Title")}
    </Typography>
    <Paper className={props.classes.paper}>
      <ControlledSubstanceDispensedReport />
    </Paper>
  </div>
);

const CancelledList = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      id="react-no-print"
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Cancelled.CancelledItemsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <CancelledLists />
    </Paper>
  </div>
);

const History = (props) => (
  <div id="react-no-print">
    <Typography variant="display1" gutterBottom>
      {props.i18n("Global.PageName.History")}
    </Typography>
    <Paper>
      <HistoryLists />
    </Paper>
  </div>
);

const ManageBoxes = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Location.ManageLocationTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <BoxList />
    </Paper>
  </div>
);
const ManageBinMapping = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Paper className={props.classes.paper}>
      <BinMapping />
    </Paper>
  </div>
);
const ManageBinOrderMappings = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Paper className={props.classes.paper}>
      <BinOrderMappings />
    </Paper>
  </div>
);
const ManageBinMovementHistory = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Paper className={props.classes.paper}>
      <BinMovementHistory />
    </Paper>
  </div>
);
const ManagePatients = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {[false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail"))
        ? props.i18n("Leftbar.ManagePatient")
        : props.i18n("Leftbar.ManageCustomers")}
    </Typography>
    <Paper className={props.classes.paper}>
      <PatientList />
    </Paper>
  </div>
);
const ManageUsers = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Users.ManageUsersTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <UserList />
    </Paper>
  </div>
);

const ManageVendors = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Vendors.ManageVendorsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <VendorList />
    </Paper>
  </div>
);

const ManageRolePermissions = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Role.RolePermissionsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <RolePermissions />
    </Paper>
  </div>
);

const ManageInheritPermissions = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Typography
        variant="display1"
        gutterBottom
        className={props.classes.typography}
      >
        {props.i18n("Role.PushPermission")}
      </Typography>
      <Tooltip title="Push permissions from 'From' account to 'To' account">
        <IconButton sx={{ mt: "-4px" }}>
          <HelpOutlineIcon sx={{ fontSize: 28 }} />
        </IconButton>
      </Tooltip>
    </div>

    <Paper className={props.classes.paper}>
      <InheritPermissions />
    </Paper>
  </div>
);

const ManageAccounts = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Accounts.ManageAccountsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <AccountList />
    </Paper>
  </div>
);

const Console = (props) => (
  <Box component="div" className={props.classes.main} sx={{ mb: "25px" }}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
      id="react-no-print"
    >
      {props.i18n("Console.ConsoleTile")}
    </Typography>
    <ConsolePage />
  </Box>
);

const AssigneditemsDelivery = (props) => (
  <div id="react-no-print">
    <Typography variant="display1" gutterBottom>
      {props.i18n("Report.Assign.AssignedItemsTitle")}
    </Typography>
    <div>
      <AssignedItemDeliveryPage />
    </div>
  </div>
);

const OutOfDelivery = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.OutForDelivery.OutForDeliveryTitle")}
    </Typography>
    <div className={props.classes.paper}>
      <OutofDeliveryPage />
    </div>
  </div>
);

const StockedItemsDelivery = (props) => (
  <div id="react-no-print">
    <Typography variant="display1" gutterBottom>
      {props.i18n("Global.PageName.StockedItems")}
    </Typography>
    <div>
      <StockedItemDeliveryPage />
    </div>
  </div>
);

const MyDeliveries = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Delivered.DeliveredItemsTitle")}
    </Typography>
    <div className={props.classes.paper}>
      <MyDeliveryPage />
    </div>
  </div>
);

const PendingDeliveries = (props) => (
  <div id="react-no-print">
    <Typography variant="display1" gutterBottom>
      {props.i18n("Global.PageName.PendingDeliveries")}
    </Typography>
    <Paper>
      <PendingDeliveriesPage />
    </Paper>
  </div>
);

const AddPatient = (props) => (
  <div id="react-no-print">
    <Typography variant="display1" gutterBottom>
      {props.i18n("Global.PageName.AddPatient")}
    </Typography>
    <Paper>
      <UserAdd />
    </Paper>
  </div>
);
const AddUser = (props) => (
  <div id="react-no-print">
    <Typography variant="display1" gutterBottom>
      {props.i18n("Global.PageName.AddUser")}
    </Typography>
    <Paper>
      <UserAdd />
    </Paper>
  </div>
);
const AssignedItem = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      id="react-no-print"
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Assign.AssignedItemsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      {[false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail")) ? (
        <AssignedItems />
      ) : (
        <RetailAssignedItems />
      )}
    </Paper>
  </div>
);

const EnrolledPatient = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Patient.PatientListTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <EnrolledPatients />
    </Paper>
  </div>
);

const ExpiredItem = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Expired.ExpiredItemsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      {[false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail")) ? (
        <ExpiredItems />
      ) : (
        <RetailRemovedItems />
      )}
    </Paper>
  </div>
);

const SurveyData = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Survey.SurveyTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <SurveyReport />
    </Paper>
  </div>
);

const Consultation = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Consult.ConsultReportTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <ConsultReport />
    </Paper>
  </div>
);

const ScheduleConsultation = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Schedule.ScheduleConsultReportTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <ScheduleConsultReport />
    </Paper>
  </div>
);

const IpayTransactionsreport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.iPay.iPayTransactionTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <IpayTransactions />
    </Paper>
  </div>
);


const IpayReceivablesreport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.iPay.iPayReceivablesTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <IpayReceivables />
    </Paper>
  </div>
);



const TemparatureMonitoringreport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Temperature.TemperatureMonitoringTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <TemparatureMonitoring />
    </Paper>
  </div>
);

const EnrolledLoyaltyMembersReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Loyalty.EnrolledLoyaltyMemberTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <EnrolledLoyaltyMembers />
    </Paper>
  </div>
);

const OrderViewReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.OrderStaging.OrderStagingViewTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <OrderView />
    </Paper>
  </div>
);

const ConsoleReports = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Leftbar.ConsoleReport")}
    </Typography>
    <Paper className={props.classes.paper}>
      <ConsoleReport />
    </Paper>
  </div>
);

// const Appointments = (props) => (
//   <div id="react-no-print" className={props.classes.main}>
//     <Typography
//       variant="display1"
//       gutterBottom
//       className={props.classes.typography}
//     >
//       {props.i18n("Appointment.AppointmentTitle")}
//     </Typography>
//     <Paper className={props.classes.paper}>
//       <Appointment />
//     </Paper>
//   </div>
// );

const ReleaseHistorys = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Announcement.AnnouncementTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <ReleaseHistory />
    </Paper>
  </div>
);

const InActiveUsersReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.inActive.inActiveUserReportTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <InActiveUsersReportComponent />
    </Paper>
  </div>
);

const Temp = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.TemperatureHis.TemperatureHistoryTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <TemperatureHistory />
    </Paper>
  </div>
);

const KioskBoxUtilization = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.KioskUtil.KioskUtilizationTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <KioskBoxUtilizationComponent />
    </Paper>
  </div>
);

const PayrollDeduction = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Payroll.PayrollDeductionsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <PayrollDeductions />
    </Paper>
  </div>
);

const Automation = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Global.PageName.Automation")}
    </Typography>
    <Paper className={props.classes.paper}>
      <EmailAutomationComponent />
    </Paper>
  </div>
);

const TaskManager = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Task.TaskManager")}
    </Typography>
    <Paper className={props.classes.paper}>
      <TaskManagerComponent />
    </Paper>
  </div>
);

const PhiLogsList = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.phiLogs.PhiLogsTitle")}&nbsp;
      <Tooltip key="single-delete" title={props.i18n("Report.phiLogs.toolTip")}>
        <IconButton aria-label="info">
          <InfoRounded />
        </IconButton>
      </Tooltip>
    </Typography>
    <Paper className={props.classes.paper}>
      <PhiLogs />
    </Paper>
  </div>
);


const CreateOrders = (props) => (
  <Box component="div" className={props.classes.main}>
    <Typography
      id="react-no-print"
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Leftbar.CreateLockerPickup")}
    </Typography>
    <Box component="div">
      <CreateOrder />
    </Box>
  </Box>
);

const VendorOrderReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.VendorOrders.VendorOrdersTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <VendorOrders />
    </Paper>
  </div>
);

const AuditReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.Audit.AuditReport")}
    </Typography>
    <Paper className={props.classes.paper}>
      <AuditReportComponent />
    </Paper>
  </div>
);

const PurgeTrailReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.purgeTrail.ReportTitle")}&nbsp;
    </Typography>
    <Paper className={props.classes.paper}>
      <PurgeTrail />
    </Paper>
  </div>
);

const CycleReviewReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.CycleReview")}&nbsp;
    </Typography>
    <Paper className={props.classes.paper}>
      <CycleReview />
    </Paper>
  </div>
);

const HLOrderViewReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.HLOrderStaging.HLOrderStagingViewTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <HLOrderView />
    </Paper>
  </div>
);

const MessageLogReport = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.MessageLog.MessageLogTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <MessageLog />
    </Paper>
  </div>
)

const ManageGroups = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Groups.ManageGroupsTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <GroupManagement />
    </Paper>
  </div>
);

const ManageRoles = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Roles.ManageRolesTitle")}
    </Typography>
    <Paper className={props.classes.paper}>
      <RoleManagement />
    </Paper>
  </div>
);

const ComplianceReconciliationList = (props) => (
  <div id="react-no-print" className={props.classes.main}>
    <Typography
      variant="display1"
      gutterBottom
      className={props.classes.typography}
    >
      {props.i18n("Report.ComplianceReconciliation")}
    </Typography>
    <Paper className={props.classes.paper}>
        <ComplianceReconciliation />
    </Paper>
  </div>
);

let oktaAuthClient = window.oktaAuthClient;

let configPingOIDC = {
  response_type: "code",
  scope: "openid profile email address",
  code_challenge: cookies.getCookie("code_challenge"),
  code_verifier: cookies.getCookie("code_verifier"),
  code_challenge_method: "S256",
  response_mode: "query",
};

const handlePingUserInfo = async (config) => {
  await pingOIDC
    .getUserInfo(config)
    .then((result) => {
      configPingOIDC.userInfo = result;
      console.log("handlePingUserInfo :: ", { result });
    })
    .catch((error) => {
      const errorDetail = _.get(error, "details[0].code", null);
      if (_.isEqual(errorDetail, "INVALID_VALUE")) {
        if (
          _.get(error, "details[0].message", null).includes(
            "Access token expired"
          )
        ) {
          configPingOIDC.errorMessage =
            "Your access token is expired. Please login again.";
          alertStatusPingOIDC(configPingOIDC.errorMessage);
        } else {
          configPingOIDC.errorMessage = _.get(
            error,
            "details[0].message",
            null
          );
          alertStatusPingOIDC(configPingOIDC.errorMessage);
        }
      } else if (errorDetail) {
        configPingOIDC.errorMessage =
          errorDetail + _.get(error, "details[0].message", null);
        alertStatusPingOIDC(configPingOIDC.errorMessage);
      } else if (
        _.get(error, "error", null) ||
        _.get(error, "error_description", null)
      ) {
        configPingOIDC.errorMessage =
          _.get(error, "error", null) +
          ": " +
          _.get(error, "error_description", null);
        alertStatusPingOIDC(configPingOIDC.errorMessage);
      }
      return Promise.reject(error);
    });
};

const verifyPingUserToken = async (configPingOIDC) => {
  await pingOIDC
    .verifyIdToken(configPingOIDC)
    .then(async (idTokenJson) => {
      configPingOIDC.idTokenJson = idTokenJson;
      await getAuthUserFromOIDC({
        value: configPingOIDC.id_token,
        claims: {
          ...idTokenJson,
          name:
            idTokenJson.given_name + " " + idTokenJson.family_name ||
            idTokenJson.displayName,
          email: idTokenJson.userPrincipalName,
        },
      });
      console.log({ configPingOIDC });
    })
    .catch((error) => {
      console.error(error);
      const status = {
        errorMessage:
          "Id token verification failed. " +
          _.get(error, "error_description", _.get(error, "message", error)),
      };
      alertStatusPingOIDC(status);
    });
};

const alertStatusPingOIDC = (status) => {
  console.log({ configPingOIDC, status });
  // alert(JSON.stringify(status));
};

const getAuthUserFromOIDC = async (idToken) => {
  const token = idToken.value || idToken;
  token &&
    (await fetch(process.env.REACT_APP_BASEURL + "auth/oidc/users", {
      method: "POST",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then(async (uData) => {
        if (uData.success) {
          sessionStorage.setItem(
            "user",
            JSON.stringify({
              signInUserSession: {
                idToken: {
                  jwtToken: idToken.value || idToken,
                  payload: {
                    ...idToken.claims,
                  },
                },
              },
              username: idToken.claims.email,
            })
          );
          sessionStorage.setItem("parentAccountName", uData.parentAccount.name);
          sessionStorage.setItem("parentAccountId", uData.parentAccount.id);
          sessionStorage.setItem("timeZone", uData.parentAccount.timezone);
          persistAutoLogoutAccountSetting(uData.parentAccount);
          if (uData.group) {
            sessionStorage.setItem("groupName", uData.group.name || "");
            sessionStorage.setItem("groupID", uData.group.id || "");
            sessionStorage.setItem("groupType", uData.group.type_id || "");
          } else if (uData.group_id) {
            try {
              const groupResponse = await fetch(
                process.env.REACT_APP_BASEURL + "groups/search",
                {
                  method: "GET",
                  withCredentials: true,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                  },
                }
              );
              if (!groupResponse.ok) {
                throw new Error("groups/search responded with " + groupResponse.status);
              }
              const groupData = await groupResponse.json();
              const userGroup = groupData && groupData.data
                ? groupData.data.find(g => g.id === uData.group_id)
                : null;
              if (userGroup) {
                sessionStorage.setItem("groupName", userGroup.name || "");
                sessionStorage.setItem("groupID", userGroup.id || "");
                sessionStorage.setItem("groupType", userGroup.type_id || "");
              } else {
                sessionStorage.setItem("groupName", "");
                sessionStorage.setItem("groupID", "");
                sessionStorage.setItem("groupType", "");
              }
            } catch (err) {
              console.error("Failed to fetch group info for SSO user:", err);
              sessionStorage.setItem("groupName", "");
              sessionStorage.setItem("groupID", "");
              sessionStorage.setItem("groupType", "");
            }
          } else {
            sessionStorage.setItem("groupName", "");
            sessionStorage.setItem("groupID", "");
            sessionStorage.setItem("groupType", "");
          }
          try {
            await getPermissionsAfterOIDC();
            await getPreferredLocation();
          } catch (error) {
            console.error('Failed to finish OIDC setup', error);
          } finally {
            /* audit trail entry for SSO user login */
            sessionStorage.setItem('loginMethod', 'SSO');
            await writeAuditLog('User logged in to connect via SSO.', 'Login', {}, {}, { deferMs: 0, wait: true });
            
            // Set up token expiry handler for auto-logout
            const ssoUser = JSON.parse(sessionStorage.getItem('user'));
            setupTokenExpiryHandler(ssoUser, { loginMethod: 'SSO' });
            
            // Check for browser setting changes after 1 minute (allows time for permission prompts)
            checkBrowserDetailsAfterLogin(60000);
          }
        } else {
          console.error(uData.message);
        }
      })
      .catch((error) => {
        if (error && error.response) {
          console.error(error.response);
        }
      }));
};

const getPermissionsAfterOIDC = async () => {
  await fetch(process.env.REACT_APP_BASEURL + "getRolesPermissions", {
    method: "GET",
    withCredentials: true,
    headers: {
      Authorization:
        "Bearer " +
        JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
          .jwtToken,
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((Permissons) => {
      if (Permissons.permission) {
        // Added by manav
        sessionStorage.setItem(
          "permissions",
          JSON.stringify(Permissons.permission)
        );
      }
      if (Permissons.user) {

        if (Permissons.user.first_name || Permissons.user.last_name) {
          sessionStorage.setItem('user.firstname', Permissons.user.first_name);
          sessionStorage.setItem('user.lastname', Permissons.user.last_name);
        }
        else {
          sessionStorage.setItem('user.firstname', Permissons.user.name);
        }

        let roles;
        if (Permissons.user.roles.length > 0) {
          sessionStorage.setItem(
            "permissionUser",
            JSON.stringify(Permissons.user.roles[0].id)
          );
          roles = Permissons.user.roles;
          roles.forEach((element) => {
            if (element.id === USER_ROLES.PHARMACIST) {
              sessionStorage.setItem("roleId", JSON.stringify(element.id));
            }
            if (element.id === USER_ROLES.ADMIN) {
              sessionStorage.setItem("admin", JSON.stringify(element.id));
            }
            if (element.id === USER_ROLES.SUPERADMIN) {
              sessionStorage.setItem("superadmin", JSON.stringify(element.id));
            }
            if (element.id === USER_ROLES.DELIVERYTECH) {
              sessionStorage.setItem(
                "deliverytech",
                JSON.stringify(element.id)
              );
            }
          });
          navigate(`/home`);
        }
      }
    });
};

const fetchOIDCDetails = async (username) => {
  fetch(process.env.REACT_APP_BASEURL + "auth/oidc/" + username, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    })
    .then((uData) => {
      if (uData.success) {
        console.log({ uData });
        return {
          issuer: uData.issuer || uData.parentAccount.issuer,
          emailDomain: uData.emailDomain || uData.parentAccount.email_domain,
          clientId: uData.clientId || uData.parentAccount.client_id || "",
        };
      }
    })
    .catch((error) => {
      if (error && error.response) {
        console.error(error.response);
      }
      return {};
    });
};

const handleOktaLogin = async (commonConfig, preventLoginRedirect) => {
  const config = {
    ...commonConfig,
    scopes: ["openid", "profile", "email"],
    pkce: true,
    disableHttpsCheck: true,
    devMode: true,
  };

  // initiating OktaAuth instance
  if (!oktaAuthClient) {
    oktaAuthClient = new OktaAuth(config);
    window.oktaAuthClient = oktaAuthClient;
  }
  if (oktaAuthClient.isLoginRedirect()) {
    // Parse token from redirect url
    const data = await oktaAuthClient.token.parseFromUrl();
    const { idToken } = data.tokens;
    oktaAuthClient.tokenManager.setTokens(data.tokens);
    await getAuthUserFromOIDC(idToken);
  } else {
    // Attempt to retrieve ID Token from Token Manager
    const idToken = await oktaAuthClient.tokenManager.get("idToken");
    if (idToken) {
      // User already logged in
      console.log(`Hi ${idToken.claims.email}!`);
      await getAuthUserFromOIDC(idToken);
    } else {
      if (!preventLoginRedirect) {
        const transaction = await oktaAuthClient.signInWithRedirect();
        if (transaction.status === "SUCCESS") {
          oktaAuthClient.token.getWithRedirect();
        }
      }
    }
  }
};

const handleSAMLLogin = async () => {
  const emailDomain = (await window.cookieStore.get("emailDomain")).value;
  console.log("inside SAML auth");
  if (!emailDomain) return false;

  const samlRedirectToLogin = () => {
    window.location.href = `${process.env.REACT_APP_BASEURL}saml/${emailDomain.split('.')[0]}/login`;
  };

  console.log({ emailDomain });
  axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASEURL}saml/${
      emailDomain.split(".")[0]
    }/whoami`,
    withCredentials: true,
  })
    .then(async (response) => {
      console.log("samlResponse", response);
      if (response.data && response.data.metadata) {
        if (
          ![undefined, undefined, null, null, ""].includes(
            response.data.metadata.logoutURL
          )
        ) {
          localStorage.setItem("logoutURL", response.data.metadata.logoutURL);
        }
      }
      if (response.data) {
        await getAuthUserFromOIDC({
          value: response.data.user.jwtToken,
          claims: response.data.user.claims,
        });
      } else {
        samlRedirectToLogin();
      }
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.data && error.response.data.metadata) {
          if (
            ![undefined, "undefined", null, "null", ""].includes(
              error.response.data.metadata.logoutURL
            )
          ) {
            localStorage.setItem(
              "logoutURL",
              error.response.data.metadata.logoutURL
            );
          }
        }
      } else {
        console.log("SAML Error:", error.message);
      }
      samlRedirectToLogin();
    });
};

const auth = async (
  username,
  issuer = sessionStorage.getItem("issuer"),
  clientId = sessionStorage.getItem("clientId"),
  loginType = sessionStorage.getItem("loginType"),
  preventLoginRedirect,
  discoveryUrl,
) => {
  console.log("auth for SAML");
  let commonConfig = {
    issuer,
    clientId,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  };

  if (window.location.href.match("implicit/callback")) {
    if (!commonConfig.issuer && username) {
      const oidcResult = await fetchOIDCDetails(username);
      commonConfig = { ...commonConfig, ...oidcResult };
    } else if (
      !commonConfig.issuer &&
      !username &&
      window.location.href.match("iss=(.+)")
    ) {
      const issuerFromQueryString = decodeURIComponent(
        window.location.href.match("iss=(.+)")[1]
      );
      console.log(issuerFromQueryString);
      await fetch(
        process.env.REACT_APP_BASEURL +
          "auth/oidc/issuer/" +
          encodeURIComponent(issuerFromQueryString),
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      )
        .then((response) => response.json())
        .then((res) => {
          if (res.success) {
            commonConfig = {
              ...commonConfig,
              issuer: res.issuer,
              clientId: res.clientId,
            };
            sessionStorage.setItem("issuer", res.issuer);
            sessionStorage.setItem("clientId", res.clientId);
          }
        });
    }
  }

  if (window.location.href.match("saml/implicit/callback")) {
    console.log("inside saml/implicit/callback calling fetchOIDCDetails");
    username && window.cookieStore.set("emailDomain", username.split("@")[1]);
    await handleSAMLLogin();
    console.log("after handleSAMLLogin");
    return;
  }

  if (loginType !== "saml" && !commonConfig.issuer) {
    return;
  }

  if (loginType === "okta")
    await handleOktaLogin(commonConfig, preventLoginRedirect);

  if (loginType === "pingOIDC") {
    if (!discoveryUrl) {
      // Get the discoveryUrl from localStorage
      discoveryUrl = localStorage.getItem("discoveryUrl");
      console.log("discoveryUrl localstorage:", discoveryUrl);
    }
    const oidcConfig = await fetch(
      `${discoveryUrl ? discoveryUrl : commonConfig.issuer + '/.well-known/openid-configuration'}`
    ).then((res) => res.json());

    configPingOIDC = {
      ...oidcConfig,
      ...configPingOIDC,
      ...commonConfig,
    };

    if (configPingOIDC.scope && oidcConfig.custom_scope) {
      configPingOIDC.scope = oidcConfig.custom_scope;
    }

    if (!configPingOIDC.code_challenge) {
      const {
        code_verifier,
        code_challenge,
      } = await pingOIDC.generatePKCEPair();
      configPingOIDC = { ...configPingOIDC, code_verifier, code_challenge };
    }

    if (window.location.href.match("implicit/callback")) {
      const hashes = pingOIDC.parseHash();
      if (hashes.error && hashes.error_description) {
        configPingOIDC.errorMessage =
          "hashes :: " + hashes.error + ": " + hashes.error_description;
        alertStatusPingOIDC(configPingOIDC.errorMessage);
        return;
      }

      const stateMatch = window.location.href.match("[?#&]state=([^&]*)");
      if (
        stateMatch &&
        !stateMatch[1] &&
        !_.isEqual(stateMatch[1], sessionStorage.getItem("state"))
      ) {
        configPingOIDC.errorMessage =
          "stateMatch :: State parameter mismatch. ";
        alertStatusPingOIDC(configPingOIDC.errorMessage);
        delete configPingOIDC.access_token;
        delete configPingOIDC.id_token;
        delete configPingOIDC.errorMessage;
        return;
      }

      const codeMatch = window.location.href.match("[?#&]code=([^&]*)");
      // Implicit flow: access token is present in URL
      if (hashes.access_token) {
        configPingOIDC.access_token = hashes.access_token;
        console.log({ access_token: hashes.access_token });
        await handlePingUserInfo(configPingOIDC);
      }
      if (hashes.id_token) {
        configPingOIDC.id_token = hashes.id_token;
        await verifyPingUserToken(configPingOIDC);
        console.log({ hashes: hashes });
      }
      // Authorization code flow: access code is present in URL
      else if (codeMatch && codeMatch[1]) {
        await pingOIDC
          .getAccessToken(
            configPingOIDC.token_endpoint || commonConfig.issuer + "/token",
            configPingOIDC.clientId,
            codeMatch[1],
            configPingOIDC.code_verifier,
            configPingOIDC.redirectUri
          )
          .then(async (token) => {
            if (token.group === "optical" || token.group === "build-and-deploy") {
              // Encrypt the token and redirect to the optical app
              const encryptedToken = encrypt(token.id_token);
              if (encryptedToken) {
                window.location.href = `${process.env.REACT_APP_RETAIL_URL}#${encryptedToken}`;
              } else {
                console.error("Failed to encrypt token");
              }
            }
            configPingOIDC = {
              ...configPingOIDC,
              access_token: token.access_token,
              id_token: token.id_token,
            };
            // await handlePingUserInfo(configPingOIDC);
            await verifyPingUserToken(configPingOIDC);
          })
          .catch((error) => {
            configPingOIDC.errorMessage =
              "Couldn't get an access token. " +
              _.get(error, "error_description", _.get(error, "message", ""));
            alertStatusPingOIDC(configPingOIDC.errorMessage);
          });
      }
      localStorage.setItem("configPingOIDC", JSON.stringify(configPingOIDC));
      // Replace current URL without adding it to history entries
      window.history.replaceState({}, "", "/");
    } else {
      cookies.checkCookie("code_verifier") ||
        cookies.setCookie("code_verifier", configPingOIDC.code_verifier);
      cookies.checkCookie("code_challenge") ||
        cookies.setCookie("code_challenge", configPingOIDC.code_challenge);

      await pingOIDC.authorize(configPingOIDC);
    }
  }
  if (loginType === "saml") {
    username && window.cookieStore.set("emailDomain", username.split("@")[1]);
    await handleSAMLLogin();
  }
};
auth();

// Check for Counter locations to determine Bin Mapping menu visibility
const checkCounterLocations = async () => {
  const parentAccountId = sessionStorage.getItem('parentAccountId');
  if (![undefined, 'undefined', null, 'null', ''].includes(parentAccountId)) {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASEURL}getBoxesByStoreId/${parentAccountId}`, {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        }
      });
      
      if (response.ok) {
        const locationResponse = await response.json();
        // Check if there are any Counter locations
        const hasCounterLocations = locationResponse.some(
          (location) => location.location_type_id === LOCATION_TYPE.Counter
        );
        // Store flag in localStorage for menu visibility
        localStorage.setItem('hasCounterLocations', hasCounterLocations ? 'true' : 'false');
      }
    } catch (error) {
      console.error('Error checking Counter locations:', error);
      // Default to false if check fails
      localStorage.setItem('hasCounterLocations', 'false');
    }
  }
};

const getPreferredLocation = async () => {
  const loggedInUser = sessionStorage.getItem('user');
  if(![undefined, 'undefined', null, 'null', ''].includes(loggedInUser)) {
    const parsedUser = JSON.parse(loggedInUser);
    fetch(process.env.REACT_APP_BASEURL + `get/${parsedUser.username}/preferred/location`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      }
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(async (uData) => {
        if(![undefined, undefined, null, null, ''].includes(uData)) {
          const locationData = JSON.parse(uData);
          localStorage.setItem('selectedLocation', locationData.selected_location_id);
          localStorage.setItem('selectedLocationTypeId', locationData.selected_location_type_id)
          localStorage.setItem('selected_location_name', locationData.selected_location_name)
        } else {
          localStorage.setItem('selectedLocation', '');
          localStorage.setItem('selectedLocationTypeId', '')
          localStorage.setItem('selected_location_name', '')
        }
        
        // Check for Counter locations after login to set Bin Mapping menu visibility
        await checkCounterLocations();
        
        navigate(`/home`);
      }).catch((error) => {
        this.setState({ isInProgress: false })
        this.getPreferredLocation();
      })
  }
}


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
    serviceWorker.unregister();
    
    // Initialize notification handler for all pages
    initNotificationHandler();
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, t } = this.props;
    auth();

    return (
      <MultiTabProvider>
        <div className={classes.gradient}>
          <SystemNoticeBanner />
          <Router>
            <Login path="/" auth={auth} />
            <Login path="/implicit/callback" auth={auth} />
            <Login path="/saml/implicit/callback" auth={auth} />
          <Home
            path="/home"
            open={this.state.open}
            handleDrawerOpen={this.handleDrawerOpen}
            handleDrawerClose={this.handleDrawerClose}
          >
            <DashboardGate
             path={
              [false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail"))
                ? "/"
                : "/dashboard"
            } />
            <MessagingBilling path="/billing" />
            <BillingAnalytics path="/billing-analytics" />
            <InvoiceList path="/billing/invoices" />
            <AssignPrescription
              path="/prescription/assign"
              classes={classes}
              i18n={t}
            />
            <ManageBoxes path="/manage/locations" classes={classes} i18n={t} />
            <ManageBinMapping path="/manage/locations/bin-mapping" classes={classes} i18n={t} />
            <ManageBinOrderMappings path="/manage/locations/bin-order-mappings" classes={classes} i18n={t} />
            <ManageBinMovementHistory path="/manage/locations/bin-movement-history" classes={classes} i18n={t} />
            <ManagePatients
              path={
                [false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail"))
                  ? "/manage/patients"
                  : "/manage/customers"
              }
              classes={classes}
              i18n={t}
            />
            <AddPatient path="/manage/patients/add" />
            <ManageUsers
              path="/manage/users/:type"
              classes={classes}
              i18n={t}
            />
            <ManageVendors path="/manage/vendors" classes={classes} i18n={t} />
            <ManageAccounts
              path="/manage/accounts"
              classes={classes}
              i18n={t}
            />
            <Console path="/manage/console" classes={classes} i18n={t} />
            <AssigneditemsDelivery
              path="/reports/assigned-items/delivery"
              i18n={t}
            />
            <OutOfDelivery
              path="/reports/out-of-delivery/delivery"
              classes={classes}
              i18n={t}
            />
            <StockedItemsDelivery
              path="/reports/stocked-items/delivery"
              i18n={t}
            />
            <MyDeliveries
              path="reports/my-delivery/delivery"
              classes={classes}
              i18n={t}
            />
            <PendingDeliveries path="/manage/pending-deliveries" i18n={t} />
            <AddUser path="/manage/users/add" i18n={t} />
            <TransactionList
              path="/reports/transaction/TransactionLists"
              classes={classes}
              i18n={t}
            />
            <StockList
              path="/reports/stock-list/StockLists"
              classes={classes}
              i18n={t}
            />
            <PickUpList
              path="/reports/pickup/PickUpLists"
              classes={classes}
              i18n={t}
            />
            <ControlledSubstanceDispensedList
              path="/reports/controlled-substance-dispensed"
              classes={classes}
              i18n={t}
            />
            <CancelledList
              path="/reports/cancelled-list/CancelledLists"
              classes={classes}
              i18n={t}
            />
            <History path="/reports/history/history" i18n={t} />
            <AssignedItem
              path="/reports/assigned-items/assigneditems"
              classes={classes}
              i18n={t}
            />
            <EnrolledPatient
              path="/reports/enrolled-patients/enrolledpatients"
              classes={classes}
              i18n={t}
            />
            <PayrollDeduction
              path="/reports/payroll-deductions/payrollDeductions"
              classes={classes}
              i18n={t}
            />
            <UnpluggedAssignPrescription
              path="/prescription/unpluggedassign"
              classes={classes}
              i18n={t}
            />
            <ManageRolePermissions
              path="/user-role/rolepermissions"
              classes={classes}
              i18n={t}
            />
             <ManageInheritPermissions
              path="/user-role/pushPermissions"
              classes={classes}
              i18n={t}
            />
            <ExpiredItem
              path="/reports/return-to-stock/items"
              classes={classes}
              i18n={t}
            />
            <SurveyData
              path="/reports/survey-report/surveyreport"
              classes={classes}
              i18n={t}
            />
            <Consultation
              path="/reports/consultation/consultreport"
              classes={classes}
              i18n={t}
            />
            <ScheduleConsultation
              path="/reports/consultation/scheduleconsultreport"
              classes={classes}
              i18n={t}
            />
            <IpayTransactionsreport
              path="/reports/transaction/ipaytransactions"
              classes={classes}
              i18n={t}
            />
            <IpayReceivablesreport 
              path="/reports/transaction/ipayreceivables"
              classes={classes}
              i18n={t}
            />
            <TemparatureMonitoringreport
              path="/reports/temperaturemonitoring"
              classes={classes}
              i18n={t}
            />
            <EnrolledLoyaltyMembersReport
              path="/reports/enrolled-loyalty-members"
              classes={classes}
              i18n={t}
            />
            <OrderViewReport
              path="/reports/orders-view"
              classes={classes}
              i18n={t}
            />
            <VendorOrderReport
              path="/reports/vendor-orders"
              classes={classes}
              i18n={t}
            />
            <ConsoleReports
              path="reports/console-report"
              classes={classes}
              i18n={t}
            />
            <PhiLogsList path="reports/phi-logs" classes={classes} i18n={t} />
            {/* <Appointments
              path="/manage/appointment"
              classes={classes}
              i18n={t}
            /> */}
            <ReleaseHistorys
              path="/manage/releaseHistory"
              classes={classes}
              i18n={t}
            />
            <InActiveUsersReport
              path="/reports/inactive-users-report"
              classes={classes}
              i18n={t}
            />
            <Temp path="/reports/temp-report" classes={classes} i18n={t} />
            <KioskBoxUtilization
              path="/reports/kiosk-utilization"
              classes={classes}
              i18n={t}
            />
            <Automation path="/automation" classes={classes} i18n={t} />
            <TaskManager path="/taskmanager" classes={classes} i18n={t} />
            <AuditReport path="/reports/audit-trail" classes={classes} i18n={t} />
            <PurgeTrailReport path="/reports/purge-trail-report" classes={classes} i18n={t} />
            <CreateOrders
              path={
              [false, "false", undefined, 'undefined', null, 'null', ''].includes(localStorage.getItem("isRetail"))
                ? "/create-orders"
                : "/"
            }
             classes={classes} i18n={t} />
             <CycleReviewReport path="/reports/cycle-report" classes={classes} i18n={t} />
             <HLOrderViewReport
              path="/reports/hl7-orders"
              classes={classes}
              i18n={t}
            />
            <MessageLogReport path="/reports/message-log" classes={classes} i18n={t} />
            <ManageGroups path="/manage/groups" classes={classes} i18n={t} />
            <ManageRoles path="/manage/roles" classes={classes} i18n={t} />
            <ComplianceReconciliationList path="/reports/ComplianceReconciliationList" classes={classes} i18n={t} />
            </Home>
          </Router>
          <ToastContainer
            position="top-center"
            autoClose={2000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            draggable
            pauseOnHover={false}
          />
        </div>
      </MultiTabProvider>
    );
  }
}

export default withStyles(styles)(withTranslation()(App));



// WEBPACK FOOTER //
// ./src/App.js